import { createFileRoute } from '@tanstack/react-router';
import { DoorTypeStep } from '../steps/DoorTypeStep.js';

export const Route = createFileRoute('/_planner/planner/type')({
  component: DoorTypeStep,
});
